/** @jsx jsx */
import { jsx } from 'theme-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCcAmex, faCcDinersClub, faCcDiscover, faCcJcb, faCcMastercard, faCcVisa, } from '@fortawesome/free-brands-svg-icons';
import { faCreditCard } from '@fortawesome/pro-light-svg-icons';
var icons = {
    amex: faCcAmex,
    diners: faCcDinersClub,
    discover: faCcDiscover,
    jcb: faCcJcb,
    mastercard: faCcMastercard,
    visa: faCcVisa,
};
export var CardIcon = function (_a) {
    var className = _a.className, brand = _a.brand;
    return (jsx(FontAwesomeIcon, { className: className, icon: icons[brand] || faCreditCard }));
};
//# sourceMappingURL=CardIcon.js.map